// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"49e04948","787":"fc32a577"}[chunkId] + ".chunk.js";
};